// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__UXTiD","label":"Labeled_label__3en2l","divider":"Labeled_divider__3nSAD"};